import ListSearchBar from "../../ListSearchBar";
import React, { useState, ChangeEvent, FC, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import PropagateLoader from "react-spinners/PropagateLoader";
import { extractObjectName } from "../../../utilities/functions";
import { translate } from "pdf-lib";
import { useTranslate } from "../../../hooks/LanguageProvider";
import TooltipText from "../../ui/TooltipText";

interface Alarm {
  searchByPoi?: string;
  searchFieldPoi?: string;
  searchValuePoi?: string;
  subclass?: string;
  totalPoints?: number;
  ids?: number[];
}

interface PoiAlarmProps {
  alarm: any;
  onChange: (newMetrics: Alarm) => void;
  idUser?: string | number | null;
}

interface PoiResult {
  idgeof: number;
  codegeof?: string;
  namegeof: string;
  descriptiongeof?: string;
  attributesgeof?: string;
  areageof: string;
  datecreategeof: string;
  user_id: number;
  intrash: number;
  etatgeof?: string;
  numPoints?: number;
  classgeof?: string;
  typegeof?: string;
}

const PoiAlarm: FC<PoiAlarmProps> = ({ alarm, onChange, idUser }) => {
  const [searchByPoi, setSearchByPoi] = useState("36");
  const [searchFieldPoi, setSearchFieldPoi] = useState("");
  const [searchValuePoi, setSearchValuePoi] = useState("");
  const [subclass, setSubclass] = useState("");
  const [totalPoints, setTotalPoints] = useState(0);
  const [poiResults, setPoiResults] = useState<PoiResult[]>([]);
  const [pois, setPois] = useState<PoiResult[]>([]);
  const [loading, setLoading] = useState(false);
  const [loadingList, setLoadingList] = useState(false);

  const [showDiv, setShowDiv] = useState(false);
  const sessionUserId = localStorage.getItem("userid");
  const poiUserId = idUser != null ? String(idUser) : sessionUserId;
  const divRef = useRef<HTMLDivElement>(null);
  const { translate } = useTranslate();
  const [selectedPois, setSelectedPois] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);

  const [displayedPois, setDisplayedPois] = useState<PoiResult[]>([]);

  const [confirmedPois, setConfirmedPois] = useState<PoiResult[]>([]);
  const alarmIds = Array.isArray(alarm?.ids) ? alarm.ids : [];
  const alarmIdsKey = alarmIds.join(",");
  const normalizeSearchByPoi = (value?: string | number | null) =>
    String(value) === "37" ? "37" : "36";
  const POI_PAGE_SIZE_OPTIONS = [8, 15, 25, 50];
  const [poiResultsPerPage, setPoiResultsPerPage] = useState(8);
  const [poiResultsPage, setPoiResultsPage] = useState(1);
  const totalPoiResultPages = Math.max(
    1,
    Math.ceil(poiResults.length / poiResultsPerPage)
  );
  const firstPoiResultIndex = (poiResultsPage - 1) * poiResultsPerPage;
  const lastPoiResultIndex = Math.min(
    firstPoiResultIndex + poiResultsPerPage,
    poiResults.length
  );
  const paginatedPoiResults = poiResults.slice(
    firstPoiResultIndex,
    lastPoiResultIndex
  );
  const [poiPendingRemoval, setPoiPendingRemoval] = useState<PoiResult | null>(null);

  const removePoiFromSelection = (poi: PoiResult) => {
    const id = poi.idgeof.toString();
    const updatedSelected = selectedPois.filter((x) => x !== id);
    const updatedConfirmed = confirmedPois.filter((p) => p.idgeof.toString() !== id);
    const updatedDisplayed = displayedPois.filter((p) => p.idgeof.toString() !== id);

    setSelectedPois(updatedSelected);
    setConfirmedPois(updatedConfirmed);
    setDisplayedPois(updatedDisplayed);
    setPois(updatedConfirmed);
    setTotalPoints(updatedConfirmed.length);

    onChange({
      ...alarm,
      ids: updatedConfirmed.map((p) => p.idgeof),
      totalPoints: updatedConfirmed.length,
    });
  };

  const confirmPoiRemoval = () => {
    if (!poiPendingRemoval) {
      return;
    }

    removePoiFromSelection(poiPendingRemoval);
    setPoiPendingRemoval(null);
  };

 const handleCheckboxChange = (poi: PoiResult) => {
  const id = poi.idgeof.toString();
  const isSelected = selectedPois.includes(id);

  if (isSelected) {
    setPoiPendingRemoval(poi);
  } else {
    const updatedSelected = [...selectedPois, id];
    const updatedConfirmed = [...confirmedPois, poi];
    const updatedDisplayed = displayedPois.some((p) => p.idgeof === poi.idgeof)
      ? displayedPois
      : [...displayedPois, poi];

    setSelectedPois(updatedSelected);
    setConfirmedPois(updatedConfirmed);
    setDisplayedPois(updatedDisplayed);
    setPois(updatedConfirmed);
    setTotalPoints(updatedConfirmed.length);

    onChange({
      ...alarm,
      ids: updatedConfirmed.map((p) => p.idgeof),
      totalPoints: updatedConfirmed.length,
    });
  }
};



useEffect(() => {
  setSelectedPois(pois.map((p) => p.idgeof.toString()));
}, [pois]);

  const isChecked = (poiId: string) =>
    confirmedPois.some((poi) => poi.idgeof.toString() === poiId);

  //"
  const handleSelectAllChange = () => {
    setSelectAll((prev) => !prev);
    if (!selectAll) {
      const allPois = pois.filter(
        (poi) => !selectedPois.includes(poi.idgeof.toString())
      ); // POIs non sélectionnés
      allPois.forEach((poi) => addPoiToList(poi)); // Ajout de tous les POIs non sélectionnés
    } else {
      selectedPois.forEach((poiId) => removePoiFromList(poiId)); // Retirer les POIs sélectionnés
    }
  };

  // Vérifie si tous les POIs sont sélectionnés
  useEffect(() => {
    setSelectAll(pois.length > 0 && selectedPois.length === pois.length);
  }, [selectedPois, pois]);

  useEffect(() => {

    if (alarm) {
      setSearchByPoi(normalizeSearchByPoi(alarm.searchByPoi));
      setSearchFieldPoi(alarm.searchFieldPoi || "");
      setSearchValuePoi(alarm.searchValuePoi || "");
      setSubclass(alarm.subclass || "");
      setTotalPoints(alarm.totalPoints || 0);
    }
  }, [alarm]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (divRef.current && !divRef.current.contains(event.target as Node)) {
        setShowDiv(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const loadSearchPois = (event: ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    const normalizedValue = normalizeSearchByPoi(value);
    setSearchByPoi(normalizedValue);
    onChange({ ...alarm, searchByPoi: normalizedValue });
    // Hide the div when changing search criteria
    if (!searchFieldPoi.trim()) {
      setShowDiv(false);
    } else {
      searchPois(searchFieldPoi, normalizedValue);
    }
  };

  const handleSearchFieldChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchFieldPoi(value);
    onChange({ ...alarm, searchFieldPoi: value });
    setSearchValuePoi(value);
    searchPois(value);
  };

  const searchPois = async (searchValue: string, searchBy = searchByPoi) => {
    const normalizedSearch = searchValue.trim();
    const normalizedSearchBy = normalizeSearchByPoi(searchBy);

    if (!normalizedSearch) {
      setPoiResults([]);
      setPoiResultsPage(1);
      setShowDiv(false);
      return;
    }

    setLoading(true);
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(
        `${backendUrl}/api/search/${normalizedSearchBy}/${encodeURIComponent(normalizedSearch)}/${poiUserId}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const POIS = await response.json();
      const result: PoiResult[] = POIS.data;
      setPoiResults(result);
      setPoiResultsPage(1);

      // Show or hide the div based on POI results and search field
      if (normalizedSearch === "") {
        setShowDiv(false);
      } else {
        setShowDiv(result.length > 0 || loading);
      }
    } catch (error) {
      console.error("Error fetching POIs:", error);
    } finally {
      setLoading(false);
    }
  };


  const getPois = async () => {
  setLoadingList(true);
  try {
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    const response = await fetch(`${backendUrl}/api/poi/finds`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id_pois: alarmIds,
        id_user: poiUserId,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result: PoiResult[] = await response.json();

    // ✅ Initialiser les trois listes distinctes
    setDisplayedPois(result); // pour affichage
    setConfirmedPois(result); // pour alarm.ids et totalPoints
    setPois(result);
    setTotalPoints(result.length);
    setSelectedPois(result.map((poi) => String(poi.idgeof))); // cases cochées

    // ✅ Appel explicite à onChange avec les POIs confirmés
    onChange({
      ...alarm,
      ids: result.map((poi) => poi.idgeof),
      totalPoints: result.length,
    });
  } catch (error) {
    console.error('Error fetching POIs:', error);
    setDisplayedPois([]);
    setConfirmedPois([]);
    setPois([]);
    setSelectedPois([]);
    setTotalPoints(0);
  } finally {
    setLoadingList(false);
  }
};


 useEffect(() => {
  if (alarmIds.length > 0 && poiUserId) {
    getPois();
    return;
  }

  setDisplayedPois([]);
  setConfirmedPois([]);
  setPois([]);
  setSelectedPois([]);
  setTotalPoints(0);
  setLoadingList(false);
}, [alarmIdsKey, poiUserId]);
  const addPoiToList = (poi: PoiResult) => {
    // Check if the POI is already in the list
    if (!pois.find((p) => p.idgeof === poi.idgeof)) {
      const updatedPois = [...pois, poi];
      setPois(updatedPois);
      setTotalPoints(updatedPois.length);

      // Update the metrics with the new list of POIs
      onChange({
        ...alarm,
        ids: updatedPois.map((p) => p.idgeof),
        totalPoints: updatedPois.length,
      });
    }
  };

  const PoiToList = (poi: PoiResult) => {
    if (!pois.some((p) => p.idgeof === poi.idgeof)) {
      setPois((prev) => [...prev, poi]);
    }
  };

  // Fonction pour retirer un POI de la liste
  const removePoiFromList = (poiId: string) => {
    const updatedPois = pois.filter((p) => p.idgeof.toString() !== poiId); // Retire le POI de la liste
    setPois(updatedPois); // Met à jour la liste des POIs

    // Mise à jour des métriques avec la nouvelle liste des POIs
    onChange({
      ...alarm,
      ids: updatedPois.map((p) => p.idgeof),
      totalPoints: updatedPois.length,
    });
  };

const handlePoiClick = (poi: PoiResult) => {
  const id = poi.idgeof.toString();

  if (isChecked(id)) {
    removePoiFromSelection(poi);
    return;
  }

  if (!confirmedPois.find((p) => p.idgeof === poi.idgeof)) {
    const updated = [...confirmedPois, poi];
    setConfirmedPois(updated);
    setPois(updated);
    setTotalPoints(updated.length);

    onChange({
      ...alarm,
      ids: updated.map((p) => p.idgeof),
      totalPoints: updated.length,
    });
  }

  // Rendre visible dans le tableau si pas encore affiché
  if (!displayedPois.find((p) => p.idgeof === poi.idgeof)) {
    setDisplayedPois((prev) => [...prev, poi]);
  }

  setSelectedPois((prev) => (prev.includes(id) ? prev : [...prev, id]));
};

  /***********************  Speed Alarm   ************************/
  interface SpeedAlarmProps {
    alarm: any; // Adapter le type en fonction de votre structure d'alarme
    onChange: (newMetrics: any) => void; // Fonction de rappel pour mettre à jour l'état du composant parent
  }


  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    // Implémentation pour cocher toutes les lignes
  };


  const listRef = useRef<HTMLDivElement>(null);

  const renderPoiPaginationControls = () => (
    <div
      className="d-flex align-items-center justify-content-end"
      style={{
        gap: "12px",
        whiteSpace: "nowrap",
      }}
    >
      <div className="d-flex align-items-center" style={{ gap: "8px" }}>
        <span style={{ color: "#64748b", fontSize: "12px" }}>
          {translate("Rows per page")}
        </span>
        <select
          className="form-select form-select-sm"
          style={{ width: "70px" }}
          value={poiResultsPerPage}
          onChange={(event) => {
            setPoiResultsPerPage(Number(event.target.value));
            setPoiResultsPage(1);
          }}
        >
          {POI_PAGE_SIZE_OPTIONS.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>
      <span style={{ color: "#64748b", fontSize: "12px", minWidth: "92px", textAlign: "center" }}>
        {poiResults.length > 0
          ? `${firstPoiResultIndex + 1}-${lastPoiResultIndex} ${translate("out of")} ${poiResults.length}`
          : `0 ${translate("out of")} 0`}
      </span>
      <div className="btn-group btn-group-sm">
        <Button
          disabled={poiResultsPage <= 1}
          variant="light"
          onClick={() => setPoiResultsPage((page) => Math.max(1, page - 1))}
        >
          <i className="las la-angle-left" />
        </Button>
        <Button disabled variant="light" style={{ minWidth: "68px" }}>
          {poiResultsPage} / {totalPoiResultPages}
        </Button>
        <Button
          disabled={poiResultsPage >= totalPoiResultPages}
          variant="light"
          onClick={() =>
            setPoiResultsPage((page) => Math.min(totalPoiResultPages, page + 1))
          }
        >
          <i className="las la-angle-right" />
        </Button>
      </div>
    </div>
  );


  useEffect(() => {
  const handleClickOutside = (event: MouseEvent) => {
    if (listRef.current && !listRef.current.contains(event.target as Node)) {
      setShowDiv(false); // Fermer la liste si clic à l'extérieur
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);



  return (
    <div className="col-md-12" id="extra_cell" style={{ marginTop: "10px" }}>
      <div className="row" id="alarm_4_2">
        <div
          className="col-md-3 col-sm-6"
          style={{ marginTop: "2px", padding: "0px" }}
        >
          <Button
            size="sm"
            variant="outline-primary"
            onClick={() => setShowDiv(true)}
          >
            <i className="fa fa-search" /> {translate("Search POI")}
          </Button>
        </div>

    

        <div className="col-md-9 col-sm-6">
          <div
            style={{
              marginTop: "2px",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "16px", // espace entre bouton et total
            }}
          >
            {/* Total Points */}
            <div className="text-muted small">
              <span>{translate("Total points")}: </span>
              <span id="total_points">{totalPoints}</span>
            </div>

            {/* Bouton Ajouter */}
            <a
              className="btn btn-default btn-sm gp"
              href="/poi/add"
              title="Ajouter"
              data-toggle="tooltip"
              target="_blank"
              style={{ border: "1px solid #ddd" }}
            >
              <i className="fas fa-map-pin"></i> {translate("Create POI")}
            </a>
          </div>
        </div>
      </div>

      {showDiv && (
        <div
          style={{
            background: "rgba(15, 23, 42, 0.22)",
            bottom: 0,
            left: 0,
            position: "fixed",
            right: 0,
            top: 0,
            zIndex: 1050,
          }}
          onClick={() => setShowDiv(false)}
        >
          <div
            ref={listRef}
            onClick={(event) => event.stopPropagation()}
            style={{
              background: "#ffffff",
              boxShadow: "0 18px 50px rgba(15, 23, 42, 0.22)",
              display: "flex",
              flexDirection: "column",
              height: "100vh",
              marginLeft: "auto",
              padding: "18px",
              width: "max(66.666vw, min(520px, 100%))",
            }}
          >
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div>
                <strong>{translate("Select POI")}</strong>
                <div style={{ color: "#64748b", fontSize: "12px" }}>
                  {poiResults.length} {translate("results")}
                </div>
              </div>
              <button
                type="button"
                className="btn btn-sm btn-light"
                onClick={() => setShowDiv(false)}
              >
                <i className="las la-times" />
              </button>
            </div>
            <div className="d-flex align-items-center mb-3" style={{ gap: "12px" }}>
              <ListSearchBar criteria={<select
                  className="form-select"
                  name="drawer_search_by_poi"
                  value={searchByPoi}
                  onChange={loadSearchPois}
                >
                  <option value="36">{translate("Nom")}</option>
                  <option value="37">{translate("Code")}</option>
                </select>} onReset={() => handleSearchFieldChange({target:{value:""}} as ChangeEvent<HTMLInputElement>)} resetLabel={translate("Reset search")}>
<input
                  className="form-control"
                  type="text"
                  placeholder={translate("Search") + "..."}
                  value={searchFieldPoi}
                  onChange={handleSearchFieldChange}
                  autoComplete="off"
                />
</ListSearchBar>
              {poiResults.length > 0 && renderPoiPaginationControls()}
            </div>
            <div
              id="alarm_4"
              style={{
                backgroundColor: "#fff",
                flex: "1 1 auto",
                minHeight: 0,
                overflowY: "auto",
                padding: "6px",
                display: "flex",
                justifyContent: loading || poiResults.length === 0 ? "center" : "flex-start",
                alignItems: loading || poiResults.length === 0 ? "center" : "flex-start",
              }}
            >
              {loading ? (
                <PropagateLoader color="#123abc" loading size={20} />
              ) : poiResults.length > 0 ? (
                <div style={{ width: "100%" }}>
                <table
                  id="poi_table"
                  className="table table-hover table-sm mb-0"
                  style={{
                    borderCollapse: "separate",
                    borderSpacing: "0px",
                    tableLayout: "fixed",
                    width: "100%",
                  }}
                >
                  <thead>
                    <tr style={{ borderBottom: "1px solid #e0e0e0" }}>
                      <th style={{ borderRight: "none", padding: "4px 8px", textAlign: "center", width: "56px" }}></th>
                      <th style={{ borderRight: "none", padding: "4px 8px", width: "72px" }}>ID POI</th>
                      <th style={{ borderRight: "none", padding: "4px 8px" }}>{translate("Name")}</th>
                      <th style={{ borderRight: "none", padding: "4px 8px", width: "110px" }}>{translate("Code")}</th>
                      <th style={{ borderRight: "none", padding: "4px 8px", width: "120px" }}>{translate("Description")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedPoiResults.map((poi) => (
                      <tr
                        key={poi.idgeof}
                        style={{
                          cursor: "pointer",
                          borderBottom: "1px solid #eee", // ✅ bordure horizontale
                        }}
                          onClick={() => handlePoiClick(poi)}
                        >
                          <td style={{ borderRight: "none", padding: "4px 8px", textAlign: "center", verticalAlign: "middle" }}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isChecked(poi.idgeof.toString())}
                              readOnly
                              style={{ marginLeft: 0, position: "static" }}
                            />
                          </td>
                          <td style={{ borderRight: "none", padding: "4px 8px" }}>{poi.idgeof}</td>
                        <td
                          title={poi.namegeof}
                          style={{
                            borderRight: "none",
                            overflow: "hidden",
                            padding: "4px 8px",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {poi.namegeof}
                        </td>
                        <td style={{ borderRight: "none", overflow: "hidden", padding: "4px 8px", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{poi.codegeof}</td>
                        <td style={{ borderRight: "none", overflow: "hidden", padding: "4px 8px", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{poi.descriptiongeof}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                  <div
                    className="d-none"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e5e7eb",
                      borderRadius: "8px",
                      display: "none",
                      gap: "12px",
                      padding: "10px 12px",
                    }}
                  >
                    <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                      <span style={{ color: "#64748b", fontSize: "12px" }}>
                        {translate("Rows per page")}
                      </span>
                      <select
                        className="form-select form-select-sm"
                        style={{ width: "78px" }}
                        value={poiResultsPerPage}
                        onChange={(event) => {
                          setPoiResultsPerPage(Number(event.target.value));
                          setPoiResultsPage(1);
                        }}
                      >
                        {POI_PAGE_SIZE_OPTIONS.map((size) => (
                          <option key={size} value={size}>
                            {size}
                          </option>
                        ))}
                      </select>
                    </div>
                    <span style={{ color: "#64748b", fontSize: "12px" }}>
                      {poiResults.length > 0
                        ? `${firstPoiResultIndex + 1}-${lastPoiResultIndex} ${translate("out of")} ${poiResults.length}`
                        : `0 ${translate("out of")} 0`}
                    </span>
                    <div className="btn-group btn-group-sm">
                      <Button
                        disabled={poiResultsPage <= 1}
                        variant="light"
                        onClick={() => setPoiResultsPage(1)}
                      >
                        <i className="las la-angle-double-left" />
                      </Button>
                      <Button
                        disabled={poiResultsPage <= 1}
                        variant="light"
                        onClick={() =>
                          setPoiResultsPage((page) => Math.max(1, page - 1))
                        }
                      >
                        <i className="las la-angle-left" />
                      </Button>
                      <Button disabled variant="light">
                        {poiResultsPage} / {totalPoiResultPages}
                      </Button>
                      <Button
                        disabled={poiResultsPage >= totalPoiResultPages}
                        variant="light"
                        onClick={() =>
                          setPoiResultsPage((page) =>
                            Math.min(totalPoiResultPages, page + 1)
                          )
                        }
                      >
                        <i className="las la-angle-right" />
                      </Button>
                      <Button
                        disabled={poiResultsPage >= totalPoiResultPages}
                        variant="light"
                        onClick={() => setPoiResultsPage(totalPoiResultPages)}
                      >
                        <i className="las la-angle-double-right" />
                      </Button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center" style={{ color: "#64748b", maxWidth: "360px" }}>
                  <i className="fas fa-map-pin" style={{ color: "#ff7a45", fontSize: "22px", marginBottom: "10px" }} />
                  <div style={{ fontWeight: 600 }}>
                    {searchFieldPoi.trim() ? translate("No POI found") : translate("Search POI to select")}
                  </div>
                  <div style={{ fontSize: "13px", marginTop: "4px" }}>
                    {searchFieldPoi.trim()
                      ? translate("Try another POI name or code.")
                      : translate("Use the search field above to display available POIs.")}
                  </div>
                </div>
              )}
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3">
              <span style={{ color: "#64748b", fontSize: "13px" }}>
                {confirmedPois.length} {translate("selected")}
              </span>
              <Button size="sm" variant="primary" onClick={() => setShowDiv(false)}>
                {translate("Done")}
              </Button>
            </div>
          </div>
        </div>
      )}


      <div className="row p-0">
        <div className="table-responsive p-0">
          <table className="table dataTable">
            <thead className="bg-white text-uppercase">
              <tr className="ligth ligth-data">
                <th>
                  <div className="checkbox d-inline-block">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="selectAllPOI"
                      checked={selectAll}
                      onChange={handleSelectAllChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="selectAllPOI"
                    ></label>
                  </div>
                </th>
                <th>ID {translate("POI")}</th>
                <th>{translate("Name")}</th>
                <th>{translate("Code")}</th>
                <th>{translate("Description")}</th>
              </tr>
            </thead>
            <tbody className="ligth-body">
              {loadingList ? (
                <tr style={{ textAlign: "center" }}>
                  <td className="text-center" colSpan={5}>
                    <p>
                      <PropagateLoader
                        color={"#123abc"}
                        loading={loadingList}
                        size={12}
                      />
                    </p>
                  </td>
                </tr>
              ) : displayedPois.length > 0 ? (
                displayedPois.map((poi) => (
                  <tr key={poi.idgeof}>
                    <td>
                      <div className="checkbox d-inline-block">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`poi_${poi.idgeof}_cb`}
                          name="poi_id"
                          value={poi.idgeof}
                          data-numpts={poi.numPoints}
                          checked={isChecked(poi.idgeof.toString())}
                          onChange={() => handleCheckboxChange(poi)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`poi_${poi.idgeof}_cb`}
                        ></label>
                      </div>
                    </td>
                    <td>{poi.idgeof}</td>
                    <td>{poi.namegeof}</td>
                    <td>{poi.codegeof}</td>
                    <td>{poi.descriptiongeof}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>
                    {translate("No associated POI")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Modal
        show={!!poiPendingRemoval}
        onHide={() => setPoiPendingRemoval(null)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center" style={{ gap: "8px" }}>
            <i className="las la-map-marker-alt" style={{ color: "#ff7e41" }} />
            {translate("Remove POI from selection")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ marginBottom: "8px" }}>
            {translate("Remove this POI from the alarm selection?")}
          </p>
          {poiPendingRemoval && (
            <div
              style={{
                background: "#f8fafc",
                borderRadius: "8px",
                padding: "10px 12px",
              }}
            >
              <strong>{poiPendingRemoval.namegeof}</strong>
              <div style={{ color: "#64748b", fontSize: "13px" }}>
                #{poiPendingRemoval.idgeof}
                {poiPendingRemoval.codegeof ? ` - ${poiPendingRemoval.codegeof}` : ""}
              </div>
            </div>
          )}
          <small style={{ color: "#64748b", display: "block", marginTop: "10px" }}>
            {translate("This will only remove it from this alarm, not delete the POI.")}
          </small>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setPoiPendingRemoval(null)}>
            {translate("Cancel")}
          </Button>
          <Button variant="warning" onClick={confirmPoiRemoval}>
            {translate("Remove from selection")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PoiAlarm;
